import { DynamicComponent } from '@priva/components/dynamic';

import { ToasterNotification } from 'shared/notifications';

export interface AppState {
    activeDialogs?: DynamicComponent[];
    notification?: ToasterNotification;
}

export const initialAppState: AppState = {};
